<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Details</h6>
          <h1 class="header-title">My Account</h1>
        </div> <!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <div class="card" v-if="user.id">
        <div class="card-header">
          <h3 class="card-header-title">Account Details</h3>
        </div>

        <user-account-graduate v-if="$userIsGraduate"/>
        <user-account-manager v-if="$userIsManager"/>
        <user-account-coordinator v-if="$userIsCoordinator"/>
        <user-account-admin v-if="$userIsAdmin"/>
      </div><!-- /.card -->
      <user-account-password-form></user-account-password-form>

    </div><!-- /.container-fluid -->
  </div>
</template>

<script>
import { userComputed, userMethods } from 'vx/helpers'
import UserAccountGraduate from './UserAccountGraduate'
import UserAccountManager from './UserAccountManager'
import UserAccountCoordinator from './UserAccountCoordinator'
import UserAccountAdmin from './UserAccountAdmin'
import UserAccountPasswordForm from './UserAccountPasswordForm'

export default {
  components: {
    UserAccountGraduate,
    UserAccountManager,
    UserAccountCoordinator,
    UserAccountAdmin,
    UserAccountPasswordForm
  },

  computed: {
    ...userComputed
  },

  async created () {
    try {
      await this.getUser(this.id || this.$user.id)
    } catch (error) {
      this.$router.replace({ name: 'dashboard' })
    }
  },

  methods: {
    ...userMethods
  }
}
</script>
